
<script>
import myComments from './MyComments'
export default {
  extends: myComments,
  name: 'receivedComments',
  data () {
    return {
      params: {
        page: 1,
        size: 5
      }
    }
  },
  methods: {
    getDataList () {
      var params = {
        id: this.id,
        ...this.params
      }
      this.$request.weibomessageRecComments(params).then(res => {
        if (res.code === 200 && res.data) {
          if (this.params.page === 1) {
            this.comments = res.data.content
          } else if (this.comments.length < res.data.totalElements) {
            this.comments = this.comments.concat(res.data.content)
          }
          this.count = res.data.totalElements
        }
      })
    }
  },
  watch: {
    id (newVal) {
      this.params.page = 1
      if (this.id && this.name === 'receivedComments') {
        this.getDataList()
      }
    },
    name (newVal, oldVal) {
      this.params.page = 1
      if (this.id && this.name === 'receivedComments') {
        this.getDataList()
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.id && this.name === 'receivedComments') {
        this.getDataList()
      }
    })
  }
}
</script>
